module.exports = __webpack_public_path__ + "static/media/interim-receivership-order-dated-december-19-2023.ce85c7b9.pdf";